<div id="objectives-container">
  <div id="main-container">
    <!-- Form container OFFICE -->
    <div class="form-container" *ngIf="this.formSelected == 'office'">
      <div id="dropdown-years">
        <qr-dropdown
          [config]="this.dropdownYears"
          (change)="dropdownYearsChange($event)"
          [selected]="this.yearSelected"
        ></qr-dropdown>
      </div>

      <!-- Ingresos -->
      <div class="objectives-office-card">
        <ng-container *ngFor="let group of this.objectiveGroups">
          <div class="">
            <!-- Objetivo comisiones -->
            <ng-container *ngIf="group.length > 0">
              <div class="items-form" *ngFor="let row of group">
                <div class="item-container">
                  <p class="grey-800 subheading-01-semi-bold">
                    {{ row.goalName }}
                  </p>
                  <div class="input-container">
                    <qr-input
                      *ngIf="
                        !row.detailMonthlyVisible && row.updateObjectives;
                        else noinput
                      "
                      class="input-normal"
                      [config]="input"
                      [restrictDecimalInput]="true"
                      [value]="getAnnualField(row).display"
                      (valueChange)="onAnnualInput($event, row)"
                      (blurChange)="commitAnnualValue(row)"
                    ></qr-input>
                    <ng-template #noinput>
                      <p class="paragraph-01-regular">
                        {{ row.anual | truncateDecimal : 2 }}
                      </p>
                    </ng-template>
                    <qr-button
                      *ngIf="row.detailMonthlyVisible && row.updateObjectives"
                      [config]="buttonCalendar"
                      (click)="this.openMonthlyDetailed.emit(row)"
                    ></qr-button>
                    <qr-button
                      *ngIf="row.detailMonthlyVisible && !row.updateObjectives"
                      [config]="buttonCalendarNoEdit"
                      (click)="this.openMonthlyDetailed.emit(row)"
                    ></qr-button>
                  </div>
                  <p class="caption-01-regular hint">Valor anual</p>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <ng-container
          *ngIf="
            this.objectives.incomes.length == 0 &&
            this.objectives.properties.length == 0 &&
            this.objectives.rrhh.length == 0
          "
        >
          <p class="grey-600 paragraph-01-regular" id="no-data">
            No hay objetivos para el período seleccionado
          </p>
        </ng-container>
      </div>
      <!-- Ingresos END-->
    </div>
    <!-- Form container OFFICE end -->
    <!-- Form container AGENT  -->
    <div class="form-container" *ngIf="this.formSelected == 'agent'">
      <!-- Excel -->
      <div class="cards center">
        <qr-button
          [config]="buttonDownloadExcel"
          (click)="this.downloadExcel.emit(true)"
        ></qr-button>
      </div>
      <!-- Excel END -->
      <!-- Slide -->
      <div class="cards">
        <div class="items-form slide">
          <mat-slide-toggle
            color="primary"
            [checked]="this.objectives.canEdit"
            (change)="
              this.objectives.canEdit = !this.objectives.canEdit;
              this.changePermissions.emit(this.objectives.canEdit)
            "
          ></mat-slide-toggle>
          <p class="heading-02-bold">
            Permitir a todos los agentes modificar objetivos
          </p>
        </div>
      </div>
      <!-- Slide END -->
      <!-- Excepciones CONTENEDOR -->
      <div class="cards">
        <div class="title-container space-between">
          <p class="heading-02-bold">Excepciones</p>
          <qr-button
            [config]="buttonException"
            (click)="this.addException.emit(true)"
          ></qr-button>
        </div>
        <div class="items-form" *ngIf="!this.loading; else loaderskeleton">
          <div class="item-container">
            <p class="grey-600 mb-32 paragraph-01-regular">
              Los usuarios añadidos a excepciones
              <strong *ngIf="this.objectives.canEdit">NO</strong>
              <strong *ngIf="!this.objectives.canEdit">SI</strong> podrán
              modificar sus objetivos
            </p>
          </div>
          <!-- ITEM AGENTES EXCEPCIONES -->
          <ng-container *ngFor="let agent of this.objectives.agents">
            <div
              class="item-exception space-between"
              *ngIf="agent.exceptionEditObjectives"
            >
              <p class="subheading-01-semi-bold grey-900">
                {{ agent.name }} {{ agent.lastname }}
              </p>
              <qr-button
                class="button-close"
                [config]="buttonClose"
                matTooltip="Remover excepción"
                (click)="
                  this.removeException.emit({ ids: [agent.id], action: false });
                  agent.exceptionEditObjectives = false
                "
              ></qr-button>
            </div>
          </ng-container>
          <!-- ITEM AGENTES EXCEPCIONES END -->
        </div>
        <ng-template #loaderskeleton>
          <div id="loader-container">
            <qr-skeleton-loader class="sk-loader"></qr-skeleton-loader>
          </div>
        </ng-template>
      </div>
      <!-- Excepciones CONTENEDOR END -->
    </div>
    <!-- Form container AGENT END  -->

    <!-- Floating menu -->
    <div id="floating-menu">
      <div
        class="item-row"
        [ngClass]="{ selected: this.formSelected == 'office' }"
        (click)="this.formSelected = 'office'"
      >
        <p class="subheading-01-semi-bold">Oficinas</p>
      </div>
      <div
        class="item-row"
        (click)="this.formSelected = 'agent'"
        [ngClass]="{ selected: this.formSelected == 'agent' }"
      >
        <p class="subheading-01-semi-bold">Agentes</p>
      </div>
    </div>
    <!-- Floating menu -->
  </div>
</div>
